export default "__VITE_ASSET__54oYfL$Z__"